import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  capitalizeWords,
  capitalize,
} from "../../../utils/capitalize/capitalizeWord";
import {
  personal_information,
  updatePersonalInfo,
  sendOtp,
  returnHome,
  send_otp_loading,
  existing_resume,
} from "../../../Redux/ActionCreator";
import {
  saveIntoServerCache,
  getOneFromServerCache,
} from "../../../utils/saveIntoCache";
import { ToastContainer, toast } from "react-toastify";
import countryData from "country-data";
import CustomSelect from "../../common/custom_select";
import PhoneVerificatioModal from "../../common/phone_verification_modal";
import { createPortal } from "react-dom";

const EditPersonal = ({ handleClick }) => {
  const dispatch = useDispatch();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  let [phone, setPhone] = useState("");
  let [interest1, setInterest1] = useState("");
  let [interest2, setInterest2] = useState("");
  let [interest3, setInterest3] = useState("");
  const [email, setEmail] = useState("an");

  const [showJobTitle1Placeholder, setShowJobTitle1Placeholder] =
    useState(true);
  const [showJobTitle2Placeholder, setShowJobTitle2Placeholder] =
    useState(true);
  const [showJobTitle3Placeholder, setShowJobTitle3Placeholder] =
    useState(true);

  const info = useSelector((info) => info.personal_info);
  const userInfo = useSelector((e) => e.userInfo);
  const send_otp = useSelector((state) => state.send_otp);
  const verify_otp = useSelector((state) => state.otp);
  const p_profile = useSelector((e) => e.profile);
  const flowLanguage = useSelector((e) => e.t_lang.selected);

  const [verifyModal, setVerifyModal] = useState(false);
  const [resendTimed, setResendTimed] = useState(false);

  const [showFirstNamePlaceholder, setShowFirstNamePlaceholder] =
    useState(true);
  const [showLastNamePlaceholder, setShowLastNamePlaceholder] = useState(true);
  const [showCityPlaceholder, setShowCityPlaceholder] = useState(true);
  // const[ showFirstNamePlaceholder, setShowFirstNamePlaceholder ] = useState(true);
  const [showStatePlaceholder, setShowStatePlaceholder] = useState(true);
  const [showEmailPlaceholder, setShowEmailPlaceholder] = useState(true);
  const [showInterestInputs, setShowInterestInputs] = useState(false);

  useEffect(() => {
    if (!window.location.pathname.includes("/user/profile")) {
      if (info.message !== null) {
        // get the first and lastname only
        setFirstName(
          info.message?.Firstname !== undefined ? info.message?.Firstname : ""
        );
        setLastName(
          info.message?.LastName !== undefined ? info.message?.LastName : ""
        );
        setCity(
          info.message?.Address !== undefined
            ? info.message?.Address?.split(",")[0]?.trim()
            : ""
        );
        setState(
          info.message?.Address !== undefined
            ? info.message?.Address?.split(",")[1]?.trim()
            : ""
        );
        setPhone(
          info.message?.Phone_number !== undefined
            ? info.message?.Phone_number
            : userInfo.user?.phone_number
        );
        setEmail(info.message?.Email !== undefined ? info.message?.Email : "");

        
      } else {
        let cacheInfo = getOneFromServerCache("personalInfo");
        cacheInfo
          .then((res) => res.json())
          .then((res) => {
            if (res.success === true) {
              if (res.data !== null && res.data !== undefined) {
                let resObj = JSON.parse(res.data);
                // console.log("respObj", resObj);
                dispatch(personal_information(resObj));
                setFirstName(resObj?.Firstname);
                setLastName(resObj?.LastName);
                setCity(
                  resObj?.Address !== undefined
                    ? resObj?.Address?.split(",")[0]?.trim()
                    : ""
                );
                setState(
                  resObj?.Address !== undefined
                    ? resObj?.Address?.split(",")[1]?.trim()
                    : ""
                );
                setPhone(
                  resObj?.Phone_number !== undefined
                    ? resObj?.Phone_number
                    : userInfo.user?.phone_number
                );
                setEmail(resObj?.Eamil !== undefined ? resObj?.Email : "");
              }
              // console.log("Done");
            } else if (res.success === false && res.message == "Unauthorized") {
              dispatch(returnHome(res.status));
            }
          })
          .catch((err) => {
            // console.log("Error getting personal info", err)
          });
      }
    } else if (window.location.pathname.includes("/user/profile")) {
      if (p_profile.message !== null) {
        setFirstName(
          p_profile.message?.FirstName !== undefined
            ? p_profile.message?.FirstName
            : ""
        );
        setLastName(
          p_profile.message?.LastName !== undefined
            ? p_profile.message?.LastName
            : ""
        );
        setCity(
          p_profile.message?.Address !== undefined
            ? p_profile.message?.Address?.split(",")[0]?.trim()
            : ""
        );
        setState(
          p_profile.message?.Address !== undefined
            ? p_profile.message?.Address?.split(",")[1]?.trim()
            : ""
        );
        setPhone(
          p_profile.message?.Phone_number !== undefined
            ? p_profile.message?.Phone_number
            : ""
        );
        setEmail(
          p_profile.message?.Email !== undefined ? p_profile.message?.Email : ""
        );

        // consider the job interest here
        setShowInterestInputs(true);
        setInterest1(
          p_profile.message?.JobInterests !== undefined &&
            p_profile.message?.JobInterests.length > 0
            ? p_profile.message?.JobInterests[0]?.value
            : ""
        );
        setInterest2(
          p_profile.message?.JobInterests !== undefined &&
            p_profile.message?.JobInterests.length > 0
            ? p_profile.message?.JobInterests[1]?.value
            : ""
        );
        setInterest3(
          p_profile.message?.JobInterests !== undefined &&
            p_profile.message?.JobInterests.length > 0
            ? p_profile.message?.JobInterests[2]?.value
            : ""
        );
      }
    }
  }, []);

  const handleSendVerification = () => {
    // e.preventDefault();
    const final_num = phone;
    if (final_num.includes("+") && final_num?.length > 10) {
      resendTimed === false && setResendTimed(true);
      verifyModal === false && setVerifyModal(true);
      // console.log(final_num);
      dispatch(sendOtp(String(final_num)));

      if (send_otp.errMess !== null) {
        setTimeout(() => {
          toast.error(send_otp.errMess, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }, 50);
        dispatch(send_otp_loading());
      }
    } else {
      if (final_num?.length < 12) {
        setTimeout(() => {
          toast.error("Phone number must be  digit", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }, 50);
      } else {
        setTimeout(() => {
          toast.error("Please add your country code e.g +1, +2, +45", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }, 50);
      }
    }
  };

  const handleSaveCall = async () => {
    // handleNext(dispatch, firstName, lastName, nextStep);
    try {
      // if (userInfo.user?.phone_number_verified == false) {
      //   handleSendVerification();
      // } else {
        if (
          firstName !== "" &&
          lastName !== "" &&
          city !== "" &&
          state !== "" &&
          phone !== "" &&
          email !== ""
        ) {
          let personalInformation = {
            Firstname: firstName,
            LastName: lastName,
            Address: city + ", " + state,
            Phone_number: phone,
            Email: email,
            //   Secret: secret.secret,
            JobInterests: window.location.pathname.includes("/user/profile")
              ? [interest1, interest2 || "", interest3 || ""]
              : info.message?.JobInterests,
          };
          dispatch(personal_information(personalInformation));
          // save into server cache
          await saveIntoServerCache("personalInfo", personalInformation);
          // now create the basic profile here.
          // check if the person has a profile already, update the profile too
          if (
            p_profile.message !== null &&
            window.location.pathname.includes("/user/profile")
          ) {
            dispatch(updatePersonalInfo(personalInformation));
          } else if (p_profile.message == null) {
            dispatch(updatePersonalInfo(personalInformation)); // change to save_personal_details
          }
          handleClick();
        } else {
          if (firstName == "") {
            setTimeout(() => {
              toast.error("First name is required", {
                position: toast.POSITION.TOP_RIGHT,
              });
            }, 50);
          }
          if (lastName == "") {
            setTimeout(() => {
              toast.error("Last name is required", {
                position: toast.POSITION.TOP_RIGHT,
              });
            }, 50);
          }
          if (city == "") {
            setTimeout(() => {
              toast.error("City is required", {
                position: toast.POSITION.TOP_RIGHT,
              });
            }, 50);
          }
          if (state == "") {
            setTimeout(() => {
              toast.error("State is required", {
                position: toast.POSITION.TOP_RIGHT,
              });
            }, 50);
          }
          if (phone == "") {
            setTimeout(() => {
              toast.error("Phone number is required", {
                position: toast.POSITION.TOP_RIGHT,
              });
            }, 50);
          }
          if (email == "") {
            setTimeout(() => {
              toast.error("Email is required", {
                position: toast.POSITION.TOP_RIGHT,
              });
            }, 50);
          }
        }
      // }
    } catch (error) {
      throw error;
    }
  };

  /* Flag section start */
  const [disable, setDisable] = useState(false);
  const [countryCode, setCountryCode] = useState("");
  const [countryCodeCountry, setCountryCodeCountry] = useState("");
  let [inputValue, setInputValue] = useState(countryCode);

  // get te country codes data
  const countryCodes = countryData.callingCountries.all.map((country) => ({
    code: `${country.countryCallingCodes[0]}`,
    alpha2: country.alpha2,
    name: country.name,
  }));

  const handleInputChange = (e) => {
    localStorage.setItem("phone_number", e.target.value);
    let newValue = e.target.value;
    if (newValue.includes(countryCode)) {
      setInputValue(newValue);
      setPhone(newValue);
    } else {
      setInputValue(countryCode);
      setPhone(countryCode);
    }
  };

  useEffect(() => {
    // console.log(info);
    if (info?.message !== null || info?.message?.Phone_number?.includes("+")) {
      let country_code = getOneFromServerCache("country_code");
      let country_code_country = getOneFromServerCache("country_code_country");

      country_code
        .then((resp) => resp.json())
        .then((res) => {
          if (res.success == true) {
            if (res.data !== null && res.data !== undefined) {
              let response = JSON.parse(res.data);
              setCountryCode(response);
            } else {
              setCountryCode("+1");
            }
          } else if (res.success === false && res.message == "Unauthorized") {
            dispatch(returnHome(res.status));
          }
        });

      country_code_country
        .then((resp) => resp.json())
        .then((res) => {
          if (res.success === true) {
            if (res.data !== null && res.data !== undefined) {
              let response = JSON.parse(res.data);
              setCountryCodeCountry(response);
            } else {
              setCountryCodeCountry("United States");
            }
          } else if (res.success === false && res.message == "Unauthorized") {
            dispatch(returnHome(res.status));
          }
        });
    } else {
      setCountryCode("+1");
      setCountryCodeCountry("United States");
    }
  }, [info]);

  useEffect(() => {
    if (userInfo.user?.phone_number_verified == false) {
      AddCountryCode(countryCode);
    }
  }, [countryCode]);

  const AddCountryCode = (code) => {
    setPhone(code);
    phone = code;
  };

  const handleSelectCountryCode = (code) => {
    setCountryCode(code);
    setInputValue(code);
  };

  const hanldeSetCountryCodeCountry = (country) => {
    setCountryCodeCountry(country);
  };

  const verificationModal =
    send_otp.errMess === null && verifyModal && verify_otp.message === null
      ? createPortal(
          <div className="top-0 left-0 fixed bottom-0 right-0 z-10 h-screen flex justify-center items-center bg-black bg-opacity-70 backdrop-blur-[2px] ">
            <PhoneVerificatioModal
              resendCode={() => resendTimed === false && setResendTimed(true)}
              waitingEnded={() => resendTimed && setResendTimed(false)}
              resendTimed={resendTimed}
              phoneNumber={phone}
              removeModal={() => verifyModal === true && setVerifyModal(false)}
            />
          </div>,
          document.getElementById("modal")
        )
      : null;

  return (
    <>
      <div className="bg-transparent px-4 md:px-6 lg:px-8 xl:px-10 py-8 sm:max-w-[70vw] vsm:w-[90vw] flex justify-center rounded-xl my-6 max-h-[90vh]">
        <div className="sm:w-fit vsm:w-[90vw] gap-y-2 lg:gap-0 lg:h-full bg-white flex flex-col lg:justify-between rounded-lg p-6 md:p-8 h-full">
          <h2 className="text-xl font-semibold text-[#5843BD] mb-4 text-center">
            Edit your personal details.
          </h2>

          <div className="flex lg:w-full w-full flex-col lg:flex-row md:gap-8 md:justify-between justify-center mt-2">
            <div
              className={`flex w-full vsm:my-2 md:my-0 vsm:justify-center lg:justify-start`}
            >
              <div className="md:w-[400px] vsm:w-full flex vsm:justify-center md:justify-start">
                <div className="w-full">
                  <label
                    htmlFor="firstName"
                    className="text-black font-medium text-sm mb-2"
                  >
                    What's your first name?
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    className="w-full md:w-[400px] border-2 border-[#777DEA54] rounded-md py-2 px-3 placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                    value={firstName}
                    onChange={(e) => setFirstName(capitalize(e.target.value))}
                    placeholder={
                      showFirstNamePlaceholder == false ? "" : "John Doe"
                    }
                    onFocus={() => setShowFirstNamePlaceholder(false)}
                    onBlur={() => setShowFirstNamePlaceholder(true)}
                  />
                </div>
              </div>
            </div>

            <div className="flex w-full gap-y-2 vsm:justify-center lg:justify-end">
              <div className="md:w-[400px] vsm:w-full flex vsm:justify-center">
                <div className="w-full">
                  <label
                    htmlFor="lastName"
                    className="text-black font-medium text-sm mb-2"
                  >
                    What is your last name?
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    className="w-full border-2 md:w-[400px] rounded-md py-2 px-3 border-[#777DEA54] placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                    value={lastName}
                    onChange={(e) =>
                      setLastName(capitalizeWords(e.target.value))
                    }
                    placeholder={
                      showLastNamePlaceholder == false ? "" : "Last name here"
                    }
                    onFocus={() => setShowLastNamePlaceholder(false)}
                    onBlur={() => setShowLastNamePlaceholder(true)}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="flex lg:w-full w-full flex-col lg:flex-row md:gap-8 md:justify-between justify-center mt-2">
            <div
              className={`flex w-full gap-y-2 vsm:my-2 md:my-0 vsm:justify-center lg:justify-start`}
            >
              <div className="md:w-[400px] vsm:w-full flex vsm:justify-center md:justify-start">
                <div className="w-full">
                  <label
                    htmlFor="city"
                    className="text-black font-medium text-sm mb-2"
                  >
                    What is your city?
                  </label>
                  <input
                    type="text"
                    id="city"
                    className="w-full md:w-[400px] border-2 border-[#777DEA54] rounded-md py-2 px-3 placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                    value={city}
                    onChange={(e) => setCity(capitalizeWords(e.target.value))}
                    placeholder={showCityPlaceholder == false ? "" : "Austin"}
                    onFocus={() => setShowCityPlaceholder(false)}
                    onBlur={() => setShowCityPlaceholder(true)}
                  />
                </div>
              </div>
            </div>

            <div className="flex w-full gap-y-2 vsm:justify-center lg:justify-end">
              <div className="md:w-[400px] vsm:w-full flex vsm:justify-center">
                <div className="w-full">
                  <label
                    htmlFor="state"
                    className="text-black font-medium text-sm mb-2"
                  >
                    What is your state?
                  </label>
                  <input
                    type="text"
                    id="state"
                    className="w-full border-2 md:w-[400px] rounded-md py-2 px-3 border-[#777DEA54] placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                    value={state}
                    onChange={(e) => setState(capitalizeWords(e.target.value))}
                    placeholder={showStatePlaceholder == false ? "" : "Texas"}
                    onFocus={() => setShowStatePlaceholder(false)}
                    onBlur={() => setShowStatePlaceholder(true)}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="flex lg:w-full w-full flex-col lg:flex-row md:gap-8 md:justify-between justify-center mt-2">
            <div
              className={`flex w-full gap-y-2 vsm:my-2 md:my-0 vsm:justify-center lg:justify-start`}
            >
              <div className="md:w-[400px] vsm:w-full flex vsm:justify-center md:justify-start">
                <div className="w-full">
                  <label
                    htmlFor="PhoneNumber"
                    className="text-black font-medium text-sm mb-2"
                  >
                    What is your phone number?
                  </label>
                  {/* <input
                            type="text"
                            id="Phone number"
                            className="w-full md:w-[400px] border-2 border-[#777DEA54] rounded-md py-2 px-3 placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            placeholder="+151237373422"
                            /> */}
                  <div className="w-full flex gap-3">
                    <CustomSelect
                      countryCodeCountry={countryCodeCountry}
                      hanldeSetCountryCodeCountry={hanldeSetCountryCodeCountry}
                      handleSelectCountryCode={handleSelectCountryCode}
                      countryCodes={countryCodes}
                      countryCode={countryCode}
                      AddCountryCode={AddCountryCode}
                    />

                    <input
                      type="string"
                      className="w-full md:w-[400px] border-2 border-[#777DEA54] rounded-md py-2 px-3 placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                      placeholder="+123 456 7890"
                      id="PhoneNumber"
                      name="Phone number"
                      value={phone}
                      onChange={handleInputChange}
                      disabled={disable}
                      // ref={phoneInputRef}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="flex w-full gap-y-2 vsm:justify-center lg:justify-end">
              <div className="md:w-[400px] vsm:w-full flex vsm:justify-center">
                <div className="w-full">
                  <label
                    htmlFor="email"
                    className="text-black font-medium text-sm mb-2"
                  >
                    What is your email?
                  </label>
                  <input
                    type="text"
                    id="email"
                    className="w-full border-2 md:w-[400px] rounded-md py-2 px-3 border-[#777DEA54] placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder={
                      showEmailPlaceholder == false ? "" : "anderson@gmail.com"
                    }
                    onFocus={() => setShowEmailPlaceholder(false)}
                    onBlur={() => setShowEmailPlaceholder(true)}
                  />
                </div>
              </div>
            </div>
          </div>

          {showInterestInputs && (
            <div className="w-full">
              <div className="flex items-center">
                <div className="flex w-full gap-y-2 vsm:justify-center lg:justify-start">
                  <div className="md:w-[400px] vsm:w-full flex vsm:justify-center">
                    <div className="w-full">
                      <label
                        htmlFor="email"
                        className="text-black font-medium text-sm mb-2"
                      >
                        Job Title 1
                      </label>
                      <input
                        type="text"
                        id="email"
                        className="w-full border-2 md:w-[400px] rounded-md py-2 px-3 border-[#777DEA54] placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                        value={interest1}
                        onChange={(e) => setInterest1(e.target.value)}
                        placeholder={
                          showJobTitle1Placeholder == false ? "" : "E.g plumber"
                        }
                        onFocus={() => setShowJobTitle1Placeholder(false)}
                        onBlur={() => setShowJobTitle1Placeholder(true)}
                      />
                    </div>
                  </div>
                </div>

                <div className="flex w-full gap-y-2 vsm:justify-center lg:justify-end">
                  <div className="md:w-[400px] vsm:w-full flex vsm:justify-center">
                    <div className="w-full">
                      <label
                        htmlFor="email"
                        className="text-black font-medium text-sm mb-2"
                      >
                        Job Title 2
                      </label>
                      <input
                        type="text"
                        id="email"
                        className="w-full border-2 md:w-[400px] rounded-md py-2 px-3 border-[#777DEA54] placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                        value={interest2}
                        onChange={(e) => setInterest2(e.target.value)}
                        placeholder={
                          showJobTitle2Placeholder == false
                            ? ""
                            : "E.g Carpenter"
                        }
                        onFocus={() => setShowJobTitle2Placeholder(false)}
                        onBlur={() => setShowJobTitle2Placeholder(true)}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex w-full gap-y-2 vsm:justify-center lg:justify-start">
                <div className="md:w-[400px] vsm:w-full flex vsm:justify-center">
                  <div className="w-full">
                    <label
                      htmlFor="email"
                      className="text-black font-medium text-sm mb-2"
                    >
                      Job Title 3
                    </label>
                    <input
                      type="text"
                      id="email"
                      className="w-full border-2 md:w-[400px] rounded-md py-2 px-3 border-[#777DEA54] placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                      value={interest3}
                      onChange={(e) => setInterest3(e.target.value)}
                      placeholder={
                        showJobTitle3Placeholder == false ? "" : "E.g Cleaner"
                      }
                      onFocus={() => setShowJobTitle3Placeholder(false)}
                      onBlur={() => setShowJobTitle3Placeholder(true)}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Navigation Buttons */}
          <div className="flex lg:w-full w-full flex-col lg:flex-row md:gap-8 md:justify-between justify-center mt-2">
            <div className="flex justify-between lg:max-w-[90vw] w-full">
              <button
                onClick={handleClick}
                className="border-[#FF6633] border flex items-center gap-x-2 text-black font-medium py-4 px-4 rounded-md"
              >
                <span className="notranslate" key={flowLanguage}>
                  {flowLanguage == "Spanish" ? "Cancelar" : "CANCEL"}
                </span>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="24" height="24" rx="12" fill="#FF6633" />
                  <path
                    d="M15.1893 18C15.1132 18 15.0412 17.9653 14.9938 17.9058L12.0561 14.2175C11.953 14.0881 11.7548 14.0927 11.6579 14.2269L9.00599 17.8964C8.95899 17.9615 8.88362 18 8.80337 18H6.07388C5.86606 18 5.74897 17.7612 5.87625 17.5969L10.132 12.1039C10.2027 12.0127 10.2017 11.8849 10.1297 11.7948L5.82441 6.40605C5.69361 6.24233 5.81018 6 6.01973 6H8.81098C8.88693 6 8.95877 6.03453 9.00621 6.09384L11.9435 9.76586C12.0469 9.89503 12.2449 9.89004 12.3416 9.75583L14.9727 6.10386C15.0197 6.03865 15.0952 6 15.1756 6H17.9053C18.1131 6 18.2302 6.23864 18.1031 6.40295L13.8676 11.8792C13.7971 11.9703 13.798 12.0978 13.8698 12.1879L18.1767 17.5942C18.3072 17.758 18.1906 18 17.9812 18H15.1893Z"
                    fill="white"
                  />
                </svg>
              </button>
              <button
                onClick={handleSaveCall}
                className="bg-[#5843BD] flex items-center gap-x-3 text-white font-medium py-3 px-4 rounded-md"
              >
                <span className="notranslate" key={flowLanguage}>
                  {flowLanguage == "Spanish" ? "GUARDAR" : "SAVE"}
                </span>
                <svg
                  width="11"
                  height="18"
                  viewBox="0 0 11 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.5 8.99891L1.5 16.3789"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9.5 9L1.5 1.62"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
      {verificationModal}
    </>
  );
};

export default EditPersonal;
